import { render, staticRenderFns } from "./SwitchToMenteeProfileModal.vue?vue&type=template&id=02cd6657&"
import script from "./SwitchToMenteeProfileModal.vue?vue&type=script&lang=js&"
export * from "./SwitchToMenteeProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports